import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
    OpenProprietaryPoliciesStateModel,
    ProprietaryOpenPolicy
} from './open-proprietary-policies.model';
import {
    CloseProprietaryPolicy,
    OpenProprietaryPolicy,
    SetProprietaryPolicyDirty
} from './open-proprietary-policies.actions';

@State<OpenProprietaryPoliciesStateModel>({
    name: 'openProprietaryPolicies',
    defaults: {
        policies: []
    }
})
@Injectable()
export class OpenProprietaryPoliciesState {

    @Selector()
    static openPolicies(state: OpenProprietaryPoliciesStateModel): ProprietaryOpenPolicy[] {
        return state.policies;
    }

    @Selector()
    static isAnyDirty(state: OpenProprietaryPoliciesStateModel): boolean {
        return state.policies.some(p => p.dirty);
    }

    @Selector()
    static getDirtyPolicies(state: OpenProprietaryPoliciesStateModel): ProprietaryOpenPolicy[] {
        return state.policies.filter(p => p.dirty);
    }

    static openPoliciesForAccount(accountId: string) {
        return (state: OpenProprietaryPoliciesStateModel): ProprietaryOpenPolicy[] => {
            return state.policies.filter(p => p.accountId === accountId);
        };
    }

    @Action(OpenProprietaryPolicy)
    openPolicy(
        ctx: StateContext<OpenProprietaryPoliciesStateModel>,
        action: OpenProprietaryPolicy
    ) {
        const state = ctx.getState();
        const existing = state.policies.find(
            p => p.contractId === action.policy.contractId
        );
        if (existing) {
            // Update metadata but preserve dirty state
            ctx.patchState({
                policies: state.policies.map(p =>
                    p.contractId === action.policy.contractId
                        ? { ...action.policy, dirty: p.dirty }
                        : p
                )
            });
        } else {
            ctx.patchState({
                policies: [...state.policies, action.policy]
            });
        }
    }

    @Action(CloseProprietaryPolicy)
    closePolicy(
        ctx: StateContext<OpenProprietaryPoliciesStateModel>,
        action: CloseProprietaryPolicy
    ) {
        const state = ctx.getState();
        ctx.patchState({
            policies: state.policies.filter(
                p => p.contractId !== action.contractId
            )
        });
    }

    @Action(SetProprietaryPolicyDirty)
    setDirty(
        ctx: StateContext<OpenProprietaryPoliciesStateModel>,
        action: SetProprietaryPolicyDirty
    ) {
        const state = ctx.getState();
        ctx.patchState({
            policies: state.policies.map(p =>
                p.contractId === action.contractId
                    ? { ...p, dirty: action.dirty }
                    : p
            )
        });
    }
}
